var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadsetDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 10V7.33334C2.66634 4.75601 4.75568 2.66667 7.33301 2.66667H8.66634C11.2437 2.66667 13.333 4.75601 13.333 7.33334V10",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 10C13.3334 9.26362 12.7364 8.66667 12 8.66667C11.2636 8.66667 10.6667 9.26362 10.6667 10V12C10.6667 12.7364 11.2636 13.3333 12 13.3333C12.7364 13.3333 13.3334 12.7364 13.3334 12V10Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 10C2.66663 9.26362 3.26358 8.66667 3.99996 8.66667C4.73634 8.66667 5.33329 9.26362 5.33329 10V12C5.33329 12.7364 4.73634 13.3333 3.99996 13.3333C3.26358 13.3333 2.66663 12.7364 2.66663 12V10Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetDark);
export default __webpack_public_path__ + "static/media/headset_dark.a1d3d0c2b9b42b94b0102b71a4a2e791.svg";
export { ForwardRef as ReactComponent };